<template>
  <section v-if="alerts.length" class="lsa-account-alerts" role="status" aria-label="Google LSA account warnings">
    <div class="lsa-alert-heading">
      <span class="lsa-alert-icon" aria-hidden="true">!</span>
      <div>
        <strong>Google LSA needs your attention</strong>
        <p>{{ alerts.length === 1 ? 'Your account has an active notice from Google.' : alerts.length + ' active notices from Google.' }}</p>
      </div>
      <a href="https://ads.google.com/localservices/" target="_blank" rel="noopener noreferrer">Open Google LSA ↗</a>
    </div>
    <ul>
      <li v-for="alert in alerts" :key="alert.title">
        <strong>{{ alert.title }}</strong>
        <span v-if="alert.title === 'Finish requirements'"> — Complete the remaining setup requirements in Google LSA.</span>
      </li>
    </ul>
    <div class="lsa-alert-updated">
      <span v-if="checkedAt">Last checked {{ formattedCheckedAt }}.</span>
      <span v-if="stale"> Updates are delayed. These are the last known notices; check Google for the current status.</span>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    alerts: { type: Array, default: () => [] },
    checkedAt: { type: String, default: null },
    stale: { type: Boolean, default: false }
  },
  computed: {
    formattedCheckedAt() {
      return new Date(this.checkedAt).toLocaleString([], { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
    }
  }
}
</script>

<style scoped>
.lsa-account-alerts { background: #fff9df; border: 1px solid #ecd283; border-left: 4px solid #d59a13; border-radius: 8px; padding: 18px 22px; margin-bottom: 24px; color: #634813; font-size: 14px; line-height: 1.5; }
.lsa-alert-heading { display: flex; align-items: flex-start; gap: 12px; }
.lsa-alert-heading strong { font-size: 16px; }
.lsa-alert-heading p { margin: 2px 0 0; }
.lsa-alert-heading a { margin-left: auto; color: #634813; font-weight: 600; white-space: nowrap; text-decoration: underline; }
.lsa-alert-icon { border: 2px solid #b77e07; border-radius: 50%; width: 24px; height: 24px; flex-shrink: 0; text-align: center; font-weight: bold; line-height: 20px; }
.lsa-account-alerts ul { margin: 14px 0 12px; padding-left: 36px; }
.lsa-account-alerts li + li { margin-top: 6px; }
.lsa-alert-updated { color: #806a3d; font-size: 12px; }
@media (max-width: 600px) { .lsa-alert-heading { flex-wrap: wrap; } .lsa-alert-heading a { margin-left: 36px; } .lsa-account-alerts { padding: 16px; } }
</style>
